var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sea-house-vgm" },
    [
      _c("div", { staticStyle: { display: "grid" } }, [
        _c(
          "div",
          {
            staticClass: "section form-column",
            staticStyle: {
              width: "100%",
              display: "initial",
              "padding-top": "10px"
            }
          },
          [
            _c(
              "el-upload",
              {
                staticStyle: { display: "inline-block", "margin-left": "5px" },
                attrs: {
                  no: "vgmImportExcel",
                  disabled: _vm.readonly,
                  data: {
                    mbl: _vm.job.mbl,
                    vgmChannel: _vm.job.vgmChannel,
                    jobUuid: _vm.job.uuid,
                    jobNo: _vm.job.jobNo
                  },
                  action: _vm.URL.seaExport.vgmImportExcel,
                  headers: { sessionId: _vm.$store.getters.userInfo.sessionId },
                  "show-file-list": false,
                  accept: ".xls, .xlsx",
                  "before-upload": _vm.beforeUpload,
                  "on-success": _vm.uploadSuccess
                }
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      slot: "trigger",
                      no: "excelImport",
                      disabled: _vm.readonly,
                      type: "primary"
                    },
                    slot: "trigger"
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.ExcelImport")))]
                )
              ],
              1
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "5px" },
                attrs: { type: "primary" },
                on: {
                  click: function($event) {
                    _vm.commandHandle(_vm.$t("SeaExport.DownloadCWTemplate"))
                  }
                }
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("SeaExport.DownloadCWTemplate")) + " "
                )
              ]
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "10px", height: "28px" },
                attrs: { no: "showLog", type: "primary" },
                on: { click: _vm.showLog }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_VGMLog")))]
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "10px", height: "28px" },
                attrs: {
                  no: "sendVgm",
                  disabled: !_vm.readonly,
                  type: "primary"
                },
                on: { click: _vm.sendVgm }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_SendVGM") + _vm.countdownMsg)
                )
              ]
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "10px", height: "28px" },
                attrs: { no: "onOperationGuide", type: "primary" },
                on: { click: _vm.onOperationGuide }
              },
              [_vm._v(_vm._s(_vm.$t("SeaExport.OperationGuide")))]
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "section form-column",
            staticStyle: {
              width: "100%",
              display: "initial",
              "padding-top": "10px",
              "margin-left": "0px"
            }
          },
          [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_VGMChannel")) + "：")
            ]),
            _c(
              "el-radio-group",
              {
                attrs: { no: "vgmChannel", disabled: _vm.readonly },
                model: {
                  value: _vm.localVgmChannel,
                  callback: function($$v) {
                    _vm.localVgmChannel = $$v
                  },
                  expression: "localVgmChannel"
                }
              },
              _vm._l(_vm.vgmChannels, function(option) {
                return _c(
                  "el-radio",
                  { key: option.code, attrs: { label: option.code } },
                  [_vm._v(_vm._s(option.chineseName))]
                )
              }),
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "section", staticStyle: { "min-height": "210px" } },
          [
            _c(
              "el-form",
              {
                attrs: {
                  "label-width": "100px",
                  "label-position": "right",
                  disabled: _vm.readonly,
                  rules: _vm.rules,
                  inline: ""
                }
              },
              [
                _c(
                  "div",
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_VGMBasicInfo")))
                    ]),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "10px", height: "28px" },
                        attrs: {
                          no: "syncInfo",
                          disabled: _vm.readonly,
                          type: "primary"
                        },
                        on: { click: _vm.syncInfo }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Synchronization")))]
                    ),
                    _c("i", {
                      staticClass: "el-icon-info",
                      staticStyle: {
                        "margin-left": "10px",
                        "margin-top": "5px",
                        "font-size": "20px",
                        color: "#1F75D5"
                      },
                      attrs: {
                        title:
                          _vm.$t(
                            "CargoMsg.Cargo_IfYouHaveSentPreStowageManifest"
                          ) +
                          _vm.$t(
                            "CargoMsg.Cargo_IfYouHaveNotSentPreStowageManifest"
                          )
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticStyle: { display: "flex", gap: "20px" } }, [
                  _c(
                    "div",
                    { staticStyle: { flex: "1" } },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { width: "100%", height: "200px" },
                        attrs: {
                          "show-side-bar": false,
                          "config-module": "11001212",
                          "grid-options": _vm.gridOptions,
                          "column-defs": _vm.vgmGroupColumnDefs,
                          "row-data": _vm.vgmInfoList
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.gridOptions.gridApi = params.api
                          },
                          "grid-ready": _vm.onGridReady
                        }
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "flex-end",
                            gap: "10px"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "add", type: "primary" },
                              on: { click: _vm.addVgmInfo }
                            },
                            [_vm._v(_vm._s(_vm.$t("Pricing.Add")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { no: "isDelete", type: "danger" },
                              on: { click: _vm.deleteVgmInfo }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { flex: "3" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "required-label",
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfLoading"),
                            prop: "portOfLoading"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "portOfLoading",
                              "static-options": _vm.cachePortList,
                              cache: false,
                              "default-value": _vm.vgmInfo.portOfLoading,
                              filterable: "",
                              clearable: "",
                              "filter-tag-names": [
                                "name",
                                "code",
                                "chineseName"
                              ],
                              "tag-name": "name",
                              "tag-value": "code",
                              "filter-type": "global",
                              placeholder: _vm.portOfLoadingPlaceholder
                            },
                            on: { parentCallBack: _vm.changePort }
                          }),
                          _c("p", { staticClass: "input-tips" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "CargoMsg.Cargo_FriendlyReminderWithPort"
                                )
                              )
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "required-label",
                          attrs: {
                            label: _vm.$t("SeaExport.ShippingCompany"),
                            prop: "shippingCompany"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "shPorts",
                              "static-options": _vm.vgmCarriers || [],
                              cache: false,
                              "default-value": _vm.vgmInfo.thirdPartyCarrier,
                              filterable: "",
                              clearable: "",
                              "filter-tag-names": [
                                "name",
                                "code",
                                "chineseName"
                              ],
                              "tag-name": "name",
                              "tag-value": "code",
                              "filter-type": "global",
                              placeholder: _vm.thirdPartyCarrierPlaceholder
                            },
                            on: { parentCallBack: _vm.changeCarrier }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "required-label",
                          attrs: { label: "MBL NO", prop: "mbl" }
                        },
                        [
                          _c("el-input", {
                            ref: "mbl",
                            attrs: { no: "mbl", maxlength: 30 },
                            on: { blur: _vm.handleMblInput },
                            model: {
                              value: _vm.vgmInfo.mbl,
                              callback: function($$v) {
                                _vm.$set(_vm.vgmInfo, "mbl", $$v)
                              },
                              expression: "vgmInfo.mbl"
                            }
                          }),
                          _c("p", { staticClass: "input-tips" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_FriendlyReminder"))
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isRongETong
                                ? _vm.isSHPort || _vm.isQDPort
                                : _vm.isSHPort,
                              expression:
                                "isRongETong ? (isSHPort || isQDPort) : isSHPort"
                            }
                          ],
                          class:
                            (_vm.isRongETong && _vm.isSHPort) ||
                            (!_vm.isRongETong && _vm.isSHPort)
                              ? "required-label"
                              : "",
                          attrs: {
                            label: _vm.$t("SeaExport.Wharf"),
                            prop: "wharf"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "wharf",
                              "static-options": _vm.cacheWharfs || [],
                              cache: false,
                              "default-value": _vm.vgmInfo.wharf,
                              filterable: "",
                              clearable: "",
                              "filter-tag-names": [
                                "name",
                                "code",
                                "chineseName"
                              ],
                              "tag-name": "name",
                              "tag-value": "code",
                              "filter-type": "global"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.vgmInfo.wharf = p.value
                              }
                            }
                          }),
                          _c("p", { staticClass: "input-tips" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "CargoMsg.Cargo_TerminalInfoForReferenceOnly"
                                ) +
                                  (this.isWse
                                    ? _vm.$t(
                                        "CargoMsg.Cargo_TerminalInfoForReferenceWse"
                                      )
                                    : "")
                              )
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showSoNo,
                              expression: "showSoNo"
                            }
                          ],
                          staticClass: "required-label",
                          attrs: { label: "SO NO", prop: "soNo" }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "soNo" },
                            on: { blur: _vm.handleSoNoInput },
                            model: {
                              value: _vm.vgmInfo.soNo,
                              callback: function($$v) {
                                _vm.$set(_vm.vgmInfo, "soNo", $$v)
                              },
                              expression: "vgmInfo.soNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showVesselAndVoyage,
                              expression: "showVesselAndVoyage"
                            }
                          ],
                          staticClass: "required-label",
                          attrs: {
                            label: _vm.$t("SeaExport.Vessel"),
                            prop: "vessel"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "vessel" },
                            on: {
                              input: function($event) {
                                return _vm.toUpperCase("vessel")
                              },
                              blur: _vm.loadWharf
                            },
                            model: {
                              value: _vm.vgmInfo.vessel,
                              callback: function($$v) {
                                _vm.$set(_vm.vgmInfo, "vessel", $$v)
                              },
                              expression: "vgmInfo.vessel"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showVesselAndVoyage,
                              expression: "showVesselAndVoyage"
                            }
                          ],
                          staticClass: "required-label",
                          attrs: {
                            label: _vm.$t("SeaExport.Voyage"),
                            prop: "voyage"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "voyage" },
                            on: {
                              input: function($event) {
                                return _vm.toUpperCase("voyage")
                              },
                              blur: _vm.loadWharf
                            },
                            model: {
                              value: _vm.vgmInfo.voyage,
                              callback: function($$v) {
                                _vm.$set(_vm.vgmInfo, "voyage", $$v)
                              },
                              expression: "vgmInfo.voyage"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showVgmCutOffDate,
                              expression: "showVgmCutOffDate"
                            }
                          ],
                          staticClass: "required-label",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_VGMCutOffDate"),
                            prop: "vgmCutOffDate"
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              no: "vgmCutOffDate",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd",
                              format: "yyyy-MM-dd",
                              "picker-options": _vm.pickerOptions
                            },
                            model: {
                              value: _vm.vgmInfo.vgmCutOffDate,
                              callback: function($$v) {
                                _vm.$set(_vm.vgmInfo, "vgmCutOffDate", $$v)
                              },
                              expression: "vgmInfo.vgmCutOffDate"
                            }
                          }),
                          _c("p", { staticClass: "input-tips" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "CargoMsg.Cargo_FriendlyReminderWithCutOffTime"
                                )
                              )
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isQDPort,
                              expression: "isQDPort"
                            }
                          ],
                          staticClass: "required-label",
                          attrs: {
                            label: _vm.$t("SeaExport.Yard"),
                            prop: "station"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "station",
                              "static-options": _vm.cacheYards || [],
                              cache: false,
                              "default-value": _vm.vgmInfo.yard,
                              filterable: "",
                              clearable: "",
                              "filter-tag-names": [
                                "name",
                                "code",
                                "chineseName"
                              ],
                              "tag-name": "name",
                              "tag-value": "code",
                              "filter-type": "global"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.vgmInfo.yard = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "required-label",
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ContainerHolder")
                          }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "boxHolder" },
                              model: {
                                value: _vm.vgmInfo.boxHolder,
                                callback: function($$v) {
                                  _vm.$set(_vm.vgmInfo, "boxHolder", $$v)
                                },
                                expression: "vgmInfo.boxHolder"
                              }
                            },
                            _vm._l(_vm.boxHolders, function(option) {
                              return _c(
                                "el-radio",
                                {
                                  key: option.code,
                                  staticStyle: {
                                    display: "block",
                                    "margin-bottom": "8px"
                                  },
                                  attrs: { label: option.code }
                                },
                                [_vm._v(_vm._s(option.chineseName))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm.isRongETong && _vm.isQDPort
                        ? _c(
                            "el-form-item",
                            {
                              staticClass: "required-label",
                              attrs: {
                                label: _vm.$t("SeaExport.SendingChannelVgm")
                              }
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  staticStyle: { display: "block" },
                                  attrs: { no: "sendChannel" },
                                  model: {
                                    value: _vm.vgmInfo.sendChannel,
                                    callback: function($$v) {
                                      _vm.$set(_vm.vgmInfo, "sendChannel", $$v)
                                    },
                                    expression: "vgmInfo.sendChannel"
                                  }
                                },
                                _vm._l(_vm.vgmSendChannels, function(option) {
                                  return _c(
                                    "el-radio",
                                    {
                                      key: option.code,
                                      staticStyle: {
                                        display: "block",
                                        "margin-bottom": "8px"
                                      },
                                      attrs: { label: option.code }
                                    },
                                    [_vm._v(_vm._s(option.chineseName))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "main-content section" }, [
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.CargoInfo")))
        ]),
        _c("p", { staticStyle: { color: "red" } }, [
          _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TheShipperDeclares")))
        ]),
        _c("div", { staticClass: "operations" }, [
          _c("div", { staticClass: "triggers" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "addVgmContainer",
                      disabled: _vm.readonly,
                      type: "primary"
                    },
                    on: { click: _vm.addVgmContainer }
                  },
                  [_vm._v(_vm._s(_vm.$t("Payment.new")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "removeVgmContainer",
                      disabled: _vm.readonly,
                      type: "danger"
                    },
                    on: { click: _vm.removeVgmContainer }
                  },
                  [_vm._v(_vm._s(_vm.$t("FileHistory.Delete")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "importFromContainer",
                      disabled: _vm.readonly,
                      type: "primary"
                    },
                    on: {
                      click: function($event) {
                        return _vm.importFromContainer(true)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.GetPackingInformation")))]
                )
              ],
              1
            )
          ])
        ]),
        !_vm.showVGMWeightAddress
          ? _c(
              "div",
              {
                staticClass: "section grid-wrapper",
                staticStyle: { height: "100%" }
              },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%", "margin-top": "5px" },
                  attrs: {
                    no: "vgmGrid",
                    "config-module": "150114",
                    "grid-options": _vm.vgmGrid.gridOptions,
                    "column-defs": _vm.vgmGridColumnDefs2,
                    "row-data": _vm.vgmInfo.vgmContainers
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.vgmGrid.gridOptions.gridApi = params.api
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.showVGMWeightAddress
          ? _c(
              "div",
              {
                staticClass: "section grid-wrapper",
                staticStyle: { height: "100%" }
              },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%", "margin-top": "5px" },
                  attrs: {
                    no: "vgmGrid",
                    "config-module": "150124",
                    "grid-options": _vm.vgmGrid.gridOptions,
                    "column-defs": _vm.vgmGridColumnDefs,
                    "row-data": _vm.vgmInfo.vgmContainers
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.vgmGrid.gridOptions.gridApi = params.api
                    }
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm.vgmServiceGuide.visible
        ? _c("vgm-service-guide", {
            attrs: {
              visible: _vm.vgmServiceGuide.visible,
              ports: _vm.wseCache.portList,
              "vgm-carriers": _vm.mergeVgmCarriers
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.vgmServiceGuide, "visible", $event)
              },
              close: function($event) {
                _vm.vgmServiceGuide.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.vgmLog.visible
        ? _c("vgm-log", {
            attrs: {
              visible: _vm.vgmLog.visible,
              "job-uuid": _vm.job.uuid,
              "sea-house-cache": _vm.seaHouseCache
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.vgmLog, "visible", $event)
              },
              close: function($event) {
                _vm.vgmLog.visible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }